module.exports = __webpack_public_path__ + "static/media/snappy.3746ab12.png";